module.exports = __webpack_public_path__ + "static/media/opinion_messages.4dd249b9.svg";